@if (!currentState) {
<span>Cargando...</span>
} @else {
<app-logo-header></app-logo-header>

<div class="py-4">
  <app-step-indicator [stepData]="stepData"></app-step-indicator>
</div>

<div class="w-full">
  <ng-container [ngTemplateOutlet]="basicInfoStep"></ng-container>
</div>

<!-- Basic Info Step Template -->
<ng-template #basicInfoStep>
  <main class="space-y-4">
    <!-- Name Field -->
    <ng-container *ngTemplateOutlet="nameField"></ng-container>

    <!-- Email Field -->
    <ng-container *ngTemplateOutlet="emailField"></ng-container>

    <!-- Password Field (Only for NO_AUTH) -->
    @if (currentState.loginFlow.idProveedor === TIPO_PROVEEDOR_OAUTH.CREDENCIAL)
    {
    <ng-container [ngTemplateOutlet]="passwordField"></ng-container>
    }

    <!-- Step 1 Actions -->
    <ng-container *ngTemplateOutlet="step1Actions"></ng-container>
  </main>
</ng-template>

<!-- Name Field Template -->
<ng-template #nameField>
  <div class="form-field">
    <div class="relative">
      <input
        id="preferredName"
        type="text"
        [(ngModel)]="name"
        [readonly]="
          currentState.loginFlow.idProveedor !==
            TIPO_PROVEEDOR_OAUTH.CREDENCIAL &&
          currentState.loginFlow.idProveedor !== TIPO_PROVEEDOR_OAUTH.APPLE
        "
        [class]="getInputClasses(!!nameError) + ' peer'"
        (input)="clearNameError()"
        aria-describedby="nameError ? 'nameError' : 'nameInfo'"
        placeholder=" "
      />
      <label
        for="preferredName"
        class="absolute left-3 text-gray-500 transition-all duration-200 peer-placeholder-shown:text-base peer-placeholder-shown:top-2.5 peer-focus:-top-2 peer-focus:text-xs peer-focus:text-gray-700 peer-placeholder-shown:text-gray-500 peer-focus:bg-white peer-focus:px-1 peer-[:not(:placeholder-shown)]:-top-2 peer-[:not(:placeholder-shown)]:text-xs peer-[:not(:placeholder-shown)]:text-gray-700 peer-[:not(:placeholder-shown)]:bg-white peer-[:not(:placeholder-shown)]:px-1 pointer-events-none"
      >
        Nombre
      </label>
    </div>

    @if (nameError) {
    <div id="nameError" class="mt-1 text-red-500 text-sm font-medium">
      {{ nameError.message }}
    </div>
    } @else {

    <p id="nameInfo" class="text-xs text-gray-500 mt-1">
      Este será el nombre que se mostrará en tu perfil
    </p>
    }
  </div>
</ng-template>

<!-- Email Field Template -->
<ng-template #emailField>
  <div class="form-field">
    <div class="relative">
      <input
        id="email"
        type="email"
        [(ngModel)]="email"
        [readonly]="true"
        [disabled]="true"
        [class]="getInputClasses(!!emailError) + ' peer'"
        aria-describedby="emailError ? 'emailError' : 'emailInfo'"
      />
      <label
        for="email"
        class="absolute left-3 text-gray-500 transition-all duration-200 peer-placeholder-shown:text-base peer-placeholder-shown:top-2.5 peer-focus:-top-2 peer-focus:text-xs peer-focus:text-gray-700 peer-placeholder-shown:text-gray-500 peer-focus:bg-white peer-focus:px-1 peer-[:not(:placeholder-shown)]:-top-2 peer-[:not(:placeholder-shown)]:text-xs peer-[:not(:placeholder-shown)]:text-gray-700 peer-[:not(:placeholder-shown)]:bg-white peer-[:not(:placeholder-shown)]:px-1 pointer-events-none"
      >
        Correo Electrónico
      </label>
    </div>

    @if (emailError) {
    <div id="emailError" class="mt-1 text-red-500 text-sm font-medium">
      {{ emailError.message }}
    </div>
    } @else {
    <p id="emailInfo" class="text-xs text-gray-500 mt-1 underline">
      @if (currentState.loginFlow.idProveedor !==
      TIPO_PROVEEDOR_OAUTH.CREDENCIAL) { Este dato proviene de
      {{ TIPO_PROVEEDOR_OAUTH_NAME[currentState.loginFlow.idProveedor] }}
      }
    </p>
    }
  </div>
</ng-template>

<!-- Password Field Template -->
<ng-template #passwordField>
  <div class="form-field">
    <div class="relative">
      <input
        id="password"
        [type]="showPassword ? 'text' : 'password'"
        [(ngModel)]="password"
        [class]="getInputClasses(!!passwordError, true) + ' peer'"
        (input)="clearPasswordError()"
        aria-describedby="passwordError ? 'passwordError' : 'passwordRequirements'"
        placeholder=" "
      />
      <label
        for="password"
        class="absolute left-3 text-gray-500 transition-all duration-200 peer-placeholder-shown:text-base peer-placeholder-shown:top-2.5 peer-focus:-top-2 peer-focus:text-xs peer-focus:text-gray-700 peer-placeholder-shown:text-gray-500 peer-focus:bg-white peer-focus:px-1 peer-[:not(:placeholder-shown)]:-top-2 peer-[:not(:placeholder-shown)]:text-xs peer-[:not(:placeholder-shown)]:text-gray-700 peer-[:not(:placeholder-shown)]:bg-white peer-[:not(:placeholder-shown)]:px-1 pointer-events-none"
      >
        Ingresa tu contraseña
      </label>
      <button
        type="button"
        class="absolute inset-y-0 right-0 pr-3 flex items-center"
        (click)="togglePasswordVisibility()"
        [attr.aria-label]="
          showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'
        "
        title="Mostrar contraseña"
      >
        <i
          [class]="
            showPassword
              ? 'pi pi-eye-slash text-gray-500 hover:text-gray-700'
              : 'pi pi-eye text-gray-500 hover:text-gray-700'
          "
          class="text-base cursor-pointer transition-colors"
        ></i>
      </button>
    </div>

    @if (passwordError) {
    <div id="passwordError" class="mt-1 text-red-500 text-sm font-medium">
      {{ passwordError.message }}
    </div>
    }

    <ng-container *ngTemplateOutlet="passwordRequirements"></ng-container>
  </div>
</ng-template>

<!-- Password Requirements Template -->
<ng-template #passwordRequirements>
  <ul
    id="passwordRequirements"
    class="text-xs space-y-1 mt-2 ml-4"
    [class.text-gray-500]="password.length <= 0"
  >
    <li
      class="flex gap-2"
      [class.text-green-500]="password.length >= 6"
      [class.text-red-500]="password.length < 6"
    >
      @if (password.length >= 6) {
      <i class="pi pi-check text-green-500"></i>
      } @else {
      <i class="pi pi-times text-red-500"></i>
      } Mínimo 6 carácteres
    </li>
  </ul>
</ng-template>

<!-- Step 1 Actions Template -->
<ng-template #step1Actions>
  <div class="mt-6 space-y-3">
    <button
      type="button"
      class="tracking-wider fs-condensed w-full bg-allasRed text-white py-2.5 rounded-lg font-medium text-base hover:bg-allasRed-500 transition-colors focus:outline-none focus:ring-2 focus:ring-appPrimary-500 focus:ring-offset-2"
      (click)="continuar()"
    >
      CONTINUAR
    </button>

    <button
      type="button"
      class="tracking-wider fs-condensed w-full bg-gray-300 text-gray-800 py-2.5 rounded-lg font-medium hover:bg-gray-200 transition-colors focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2"
      (click)="goBack()"
    >
      INICIA SESIÓN SI YA TIENES UNA CUENTA
    </button>
  </div>
</ng-template>
}
